import {useCallback, useMemo, useState} from "react";
import {shareMarketplaceAPI} from "../common/api/shareMarketplaceAPI";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {
    API_SHARE_MARKETPLACE_OFFERS,
    API_SHARE_MARKETPLACE_OFFERS_REQUESTS_DECLINE,
    API_SHARE_MARKETPLACE_OFFERS_REQUESTS_REMOVE,
    API_SHARE_MARKETPLACE_OFFERS_REQUESTS_WITHDRAW,
} from "../common/api/apiConstants";

export const useMarketplaceOfferRequest = () => {

    const {initialized, authenticated, userId} = useKeycloakFunctions();

    const [isOfferRequestWithdrawnRemoved, setOfferRequestWithdrawnRemoved] = useState(false);
    const [loadingWithdrawRemoveOfferRequest, setLoadingWithdrawRemoveOfferRequest] = useState(false);
    const [errorWithdrawRemoveOfferRequest, setErrorWithdrawRemoveOfferRequest] = useState();

    const [isOfferRequestDeclinedRemoved, setOfferRequestDeclinedRemoved] = useState(undefined);
    const [loadingOfferRequestDeclineRemove, setLoadingOfferRequestDeclineRemove] = useState(false);
    const [errorOfferRequestDeclineRemove, setErrorOfferRequestDeclineRemove] = useState(null);

    const declineRemoveOfferRequestSeller = useCallback(async (offerId, buyerId, isRemove) => {
        if (initialized && authenticated && offerId) {
            // Init state per session
            setLoadingOfferRequestDeclineRemove(true);
            setErrorOfferRequestDeclineRemove();
            setOfferRequestDeclinedRemoved(false);

            try {
                await shareMarketplaceAPI.post(API_SHARE_MARKETPLACE_OFFERS + "/" + offerId + (isRemove ? API_SHARE_MARKETPLACE_OFFERS_REQUESTS_REMOVE : API_SHARE_MARKETPLACE_OFFERS_REQUESTS_DECLINE), {buyer_hapimag_member_id: buyerId, ...(isRemove && {is_buyer: false})});
                setOfferRequestDeclinedRemoved(prevValue => {
                    if (prevValue !== true) {
                        return true;
                    }
                    return prevValue;
                });
                return true;
            } catch (err) {
                setOfferRequestDeclinedRemoved(prevValue => {
                    if (prevValue !== true) {
                        return true;
                    }
                    return prevValue;
                });
                setErrorOfferRequestDeclineRemove(err);
                return false;
            } finally {
                setLoadingOfferRequestDeclineRemove(false);
            }
        }
        return false;
    }, [initialized, authenticated]);

    const withdrawRemoveOfferRequestBuyer = ({offer_id}, isAvailable) => {
        if (initialized && authenticated) {
            setLoadingWithdrawRemoveOfferRequest(true);
            setErrorWithdrawRemoveOfferRequest(null);
            setOfferRequestWithdrawnRemoved(false);

            shareMarketplaceAPI.post(
                API_SHARE_MARKETPLACE_OFFERS + "/" +
                offer_id +
                (isAvailable ? API_SHARE_MARKETPLACE_OFFERS_REQUESTS_WITHDRAW : API_SHARE_MARKETPLACE_OFFERS_REQUESTS_REMOVE),
                {
                    buyer_hapimag_member_id: userId,
                    ...(!isAvailable && {is_buyer: true})
                }
            )
                .then(() => {
                    setOfferRequestWithdrawnRemoved(true);
                })
                .catch(err => {
                    setErrorWithdrawRemoveOfferRequest(err.response);
                })
                .finally(() => {
                    setLoadingWithdrawRemoveOfferRequest(false);
                });
        }
    };

    const instance = useMemo(
        () => ({
            declineRemoveOfferRequestSeller,
            isOfferRequestDeclinedRemoved,
            loadingOfferRequestDeclineRemove,
            errorOfferRequestDeclineRemove,

            withdrawRemoveOfferRequestBuyer,
            isOfferRequestWithdrawnRemoved,
            loadingWithdrawRemoveOfferRequest,
            errorWithdrawRemoveOfferRequest,
        }),
        [
            declineRemoveOfferRequestSeller,
            isOfferRequestDeclinedRemoved,
            loadingOfferRequestDeclineRemove,
            errorOfferRequestDeclineRemove,

            withdrawRemoveOfferRequestBuyer,
            isOfferRequestWithdrawnRemoved,
            loadingWithdrawRemoveOfferRequest,
            errorWithdrawRemoveOfferRequest,
        ]
    );

    return instance;
};
